export default "__VITE_ASSET__p3xnuDu5__"